import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isInstalledApp, isReadingApp, syncManifest } from "@/lib/readingApp";

// Inside the installed Reading app, only Reading pages (and sign-in pages) can open.
const ALLOWED = /^\/(lecture|login|forgot-password|set-password|reset-pin|survey|access-ended)(\/|$)|^\/kid\/[^/]+\/reading(\/|$)|^\/reading-(certificate|survey)(\/|$)/;

export default function ReadingAppGuard() {
  const { pathname } = useLocation();
  useEffect(() => { if (!isInstalledApp()) syncManifest(pathname); }, [pathname]);
  if (isReadingApp()) return ALLOWED.test(pathname) ? null : <Navigate to="/lecture" replace />;
  if (isInstalledApp() && pathname === "/") return <Navigate to="/parent" replace />;
  return null;
}
